import * as React from 'react';
import { fetchTexts, getText } from './services/text/text-service';
import LoadingSpinner from './layout/components/LoadingSpinner';
import './styles/webshop-sweden.less';
import { connect } from 'react-redux';
import ErrorBar from './layout/components/ErrorBar/ErrorBar';
import {
    fetchCalculationData,
    fetchUpdateCalculationData
} from './epics/calculation-data';
import { HashRouter as Router, Route } from 'react-router-dom';
import { PRODUCTS_CONFIG } from './config/appConfig';
import LoadingOverlay from 'react-loading-overlay';
import { isIE, isIPad13, isMobile, isTablet } from 'react-device-detect';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import classNames from 'classnames';
import { isOkq8, isVillaagarna } from './services/partners/partnersService';
import FooterVA from './layout/components/FooterVA';

export interface DispatchToProps {
    fetchCalculationData: Function;
    fetchUpdateCalculationData: Function;
}

interface StateToProps {
    isLoading: boolean;
    stepNumber: number;
}

interface State {
    isError: boolean;
    isInitialDataLoaded: boolean;
    url: string;
}

const VillaagarnaLogo = require('./images/villaagarna.png');
const VillaagarnaLogoIE = require('./images/villaagarna_IE.png');

const okq8Logo = require('./images/okq8_logo.png');
const okq8Header = require('./images/okq8_header.png');

class App extends React.Component<StateToProps & DispatchToProps, State> {
    state = {
        isError: false,
        isInitialDataLoaded: false,
        url: window.location.href
    };

    componentDidUpdate(
        prevProps: Readonly<StateToProps & DispatchToProps>,
        prevState: Readonly<State>,
        snapshot?: any
    ) {
        if (this.state.url !== window.location.href) {
            // window.location.reload();
        }
    }

    async componentDidMount() {
        const header = document.getElementsByClassName('gj-header')[0];
        if (isVillaagarna()) {
            document.body.classList.add(
                'villaagarna-page-background-color',
                'villaagarna-container'
            );
        } else if (isOkq8()) {
            document.body.classList.add(
                'okq8-page-background-color',
                'okq8-container'
            );
        } else {
            if (isMobile) {
                if (header) {
                    document
                        .getElementsByClassName('gj-header')[0]
                        .classList.add(
                            'no-padding-bottom',
                            'page-background-color'
                        );
                }
            } else if (header) {
                document
                    .getElementsByClassName('gj-header')[0]
                    .classList.add('page-background-color');
            }
        }

        try {
            await fetchTexts();
            this.setState({ isInitialDataLoaded: true });
        } catch (err) {
            this.setState({ isError: true });
        }
    }

    render() {
        if (this.state.isInitialDataLoaded) {
            return (
                <>
                    {isVillaagarna() && (
                        <img
                            id={'villaagarnaLogo'}
                            src={isIE ? VillaagarnaLogoIE : VillaagarnaLogo}
                            alt="villaagarnaLogo"
                            width={'210px'}
                            height={'39px'}
                            className={classNames(
                                isMobile ? 'margin-mobile' : 'margin-desktop'
                                // ? 'margin-top-bottom-13 margin-left-13'
                                // : 'margin-top-13 margin-bottom-26 margin-left-39'
                            )}
                        />
                    )}

                    <div
                        className={classNames(
                            'container-no-mobile',
                            'page-main'
                        )}>
                        {isOkq8() && (
                            <>
                                {isMobile && !(isTablet || isIPad13) ? (
                                    <div className={'display-flex'}>
                                        <img
                                            id={'okq8Logo'}
                                            src={okq8Logo}
                                            alt="okq8Logo"
                                            className={classNames(
                                                isMobile
                                                    ? 'margin-top-bottom-13 margin-left-13'
                                                    : 'margin-top-13 margin-bottom-13 margin-left-39',
                                                isMobile &&
                                                    !(isTablet || isIPad13)
                                                    ? 'okq8-logo-mobile'
                                                    : 'okq8-logo'
                                            )}
                                        />
                                        {this.props.stepNumber == 2 && (
                                            <div
                                                className={classNames(
                                                    'okq8-font okq8-blue-color',
                                                    isMobile &&
                                                        !(isTablet || isIPad13)
                                                        ? 'okq8-header-text-mobile'
                                                        : 'okq8-header-text'
                                                )}>
                                                {getText(
                                                    'webshopsweden.products.car.okq8.gjInfo'
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className={'display-flex'}>
                                        <img
                                            id={'okq8Logo'}
                                            src={okq8Logo}
                                            alt="okq8Logo"
                                            className={classNames(
                                                isMobile
                                                    ? 'margin-top-bottom-13 margin-left-13'
                                                    : 'margin-top-13 margin-bottom-13 margin-left-39',
                                                isMobile &&
                                                    !(isTablet || isIPad13)
                                                    ? 'okq8-logo-mobile'
                                                    : 'okq8-logo'
                                            )}
                                        />
                                        {this.props.stepNumber == 2 && (
                                            <div
                                                className={classNames(
                                                    'okq8-font okq8-blue-color',
                                                    isMobile &&
                                                        !(isTablet || isIPad13)
                                                        ? 'okq8-header-text-mobile'
                                                        : 'okq8-header-text'
                                                )}>
                                                {getText(
                                                    'webshopsweden.products.car.okq8.gjInfo'
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className={'col-xs-23 no-padding'}>
                                    <img
                                        id={'okq8Header'}
                                        src={okq8Header}
                                        alt="okq8Header"
                                        height={'52px'}
                                        width={'100%'}
                                        className={classNames(
                                            isMobile && !(isTablet || isIPad13)
                                                ? 'okq8-header-mobile'
                                                : 'okq8-header'
                                        )}
                                    />
                                </div>
                            </>
                        )}
                        <div
                            className={classNames(
                                'row',
                                `${
                                    isVillaagarna()
                                        ? 'villaagarna-'
                                        : isOkq8()
                                        ? 'okq8-'
                                        : ''
                                }background-color-app`,
                                'app-wrapper'
                            )}>
                            <ErrorBar />
                            <LoadingOverlay
                                active={this.props.isLoading}
                                spinner={<LoadingSpinner />}
                            />
                            <Router>
                                <>
                                    <Route
                                        exact={true}
                                        path={'/'}
                                        component={PRODUCTS_CONFIG[0].component}
                                    />
                                    {PRODUCTS_CONFIG.map((product, i) => (
                                        <Route
                                            key={i}
                                            path={product.link}
                                            component={product.component}
                                        />
                                    ))}
                                </>
                            </Router>
                        </div>
                    </div>
                    {isVillaagarna() && <FooterVA />}
                </>
            );
        } else {
            return <LoadingSpinner />;
        }
    }
}

const mapStateToProps = state => ({
    isLoading: state.loading.isLoading,
    stepNumber: state.step.stepNumber
});

const mapDispatchToProps = {
    fetchCalculationData,
    fetchUpdateCalculationData
};

export default connect<{}, {}, any>(mapStateToProps, mapDispatchToProps)(App);
